import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import { Action } from 'redux-act';
import { delay, put, takeLeading } from 'redux-saga/effects';

import { fromDto as employeeFromDto } from '../../../../models/adapters/EmployeeAdapter';
import { waitBeforeFetch } from '../../../../utils/FetchState';
import {
  EmployeeFetchResponsePayload,
  employeesFetched,
  employeesFetchFailed,
  fetchEmployees,
  FetchEmployeesPayload,
} from '../../../actions/setting/company/fetchEmployees';
import getAuthenticationToken from '../../getAuthenticationToken';
import getProtectedResponse from '../../getProtectedResponse';

function createHoursFetchResponseAction(companyUuid: string, response): Action<EmployeeFetchResponsePayload> {
  const { error, employees } = response;
  if (!error) {
    return employeesFetched({ employees: employees.map((employee) => employeeFromDto(employee)), companyUuid });
  }
  return employeesFetchFailed({ companyUuid });
}

function* fetchEmployeesSaga({ payload }: Action<FetchEmployeesPayload>) {
  const token = yield getAuthenticationToken();
  const { companyUuid, fetchState } = payload;
  const milliseconds = waitBeforeFetch(fetchState);
  yield delay(milliseconds);
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.getEmployees, token, { companyUuid });
  const action = createHoursFetchResponseAction(companyUuid, response);
  yield put(action);
}

export default function* watchFetchEmployeesSaga() {
  yield takeLeading(fetchEmployees, fetchEmployeesSaga);
}
